import { atom } from 'recoil'

export const viewSectionState = atom<string | null>({
    key: 'viewSectionState',
    default: null,
})
